import { type RefObject, useEffect, useState } from 'react';

export const useScrollTrigger = (container: RefObject<HTMLElement | null>) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!container.current || visible) return;

    const observer = new IntersectionObserver((elements) => {
      if (elements[0].isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    });

    observer.observe(container.current);

    return () => observer.disconnect();
  }, [container, visible]);

  return visible;
};
